/**
 * DigitalEvent Async actions
 */
import awsRestAPI from "@/services/api/awsRestAPI";
import { evessioHttpService } from "@/services/api/digitalEventHTTPs";
import { WSS_MESSAGE_TYPES } from "@/helpers/constants";
import { isEmptyObject } from "@/helpers/ObjectHelpers";

export default {
  /**
   * Reset state
   * @param state {Object}
   * @param commit
   */
  resetState({ state, commit }) {
    clearInterval(state.socket.pingInterval);
    clearInterval(state.socket.statePullingInterval);
    if (state.socket.socket) {
      state.socket.socket.disconnect();
    }
    commit("users/resetState");
    commit("room/resetState");
    commit("socket/resetState");
    commit("chat/resetState");
    commit("videoChat/resetState");
    commit("invites/resetState");
    commit("setDefaultState");
  },
  /**
   * Load init user data
   * @param state {Object}
   * @param dispatch {Function}
   * @param commit {function}
   * @param roomSlug {String} ContentNode.type_slug (DigitalEventRoom CT)
   * @return {Promise<void>}
   */
  async loadInitData({ state, dispatch }) {
    if (!state.user) {
      await dispatch("users/getUser");
    }
    if (!state.event.context || isEmptyObject(state.event.context.children) || state.users.firstLogin) {
      await dispatch("event/getContext", { includeChildren: 1 });
    }

    if (!state.room.roomAssignments.length) {
      await dispatch("room/getRoomAssignments");
    }

    if (!state.users.userRoles.length) {
      await dispatch("users/getUserRoles");
    }
  },

  /**
   * Logout from Digital Event
   * @param dispatch {Function}
   * @param commit {Function}
   * @return {Promise<{}>}
   */
  async logout({ state, dispatch, commit }) {
    if (state.users.user) {
      await dispatch("videoChat/toggleVideoChatsFunctionality", false);
    }
    commit("calls/connectivity/clearTestResultData");
    dispatch("resetState");
    let response = await evessioHttpService.get("digital-event/logout");

    return response.data;
  },

  /**
   * Get announcements
   * @return {Promise<void>}
   */
  async getAnnouncements({ state, commit }) {
    let response = await awsRestAPI.getGroupMessages({
      groupUUID: state.event.context.EVENT_GLOBALS.EVENT_UUID,
      messageType: [WSS_MESSAGE_TYPES.ANNOUNCE_MESSAGE, WSS_MESSAGE_TYPES.BANNER_MESSAGE]
    });
    commit("socket/setAnnouncements", response.data, { root: true });

    return response.data;
  }
};
